import { useEffect } from 'react'

import { IGetSubscriptionDetailsResponse } from '../../../../api/subscription'
import { AnimatedSpinner } from '../../../../components/AnimatedSpinner'
import { CornerBadge } from '../../../../components/CornerBadge'
import { formatNumber } from '../../../../utils/numbersFormatting'
import BillingOptions from './BillingOptions'

interface IBillingTabProps {
  subscriptionDetails?: IGetSubscriptionDetailsResponse
  isFetching: boolean
  refetch: () => void
}

export default function BillingTab({
  subscriptionDetails,
  isFetching,
  refetch,
}: IBillingTabProps) {
  const { credit_usage } = subscriptionDetails || {}

  useEffect(() => {
    void refetch()
  }, [])

  const balance = credit_usage
    ? credit_usage.subscription_details.balance +
      credit_usage.pack_details.balance
    : 0

  return (
    <>
      <div className="flex gap-4 md:flex-row flex-col">
        <div className="rounded-regular p-6 tc-mv-blur text-white w-full relative overflow-hidden">
          {credit_usage &&
            credit_usage.subscription_details.status !== 'subscribed' && (
              <CornerBadge text="Canceled" />
            )}
          <div className="flex">
            <div>
              <div className="text-[12px] text-[#C1C1CA]">
                Your current plan
              </div>
              <div className="text-2xl font-medium">
                {isFetching ? (
                  <AnimatedSpinner />
                ) : subscriptionDetails?.billingDetails.paymentType ===
                  'Free' ? (
                  'Unsubscribed'
                ) : (
                  subscriptionDetails?.billingDetails?.planName
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="rounded-regular p-6 tc-mv-blur text-white w-full">
          <div className="text-[12px] text-[#C1C1CA]">Available Minutes</div>
          <div className=" self-center ml-auto text-2xl font-medium">
            {isFetching ? (
              <AnimatedSpinner />
            ) : (
              balance && formatNumber(balance / 60)
            )}
          </div>
        </div>
      </div>
      <div className="rounded-regular p-6 tc-mv-blur text-white mt-4">
        <h5>Billing information</h5>
        <hr className=" border-[#32323B] my-4" />
        <BillingOptions />
      </div>
    </>
  )
}
